import { html, LitElement } from 'lit';

class IconArrowDown extends LitElement {
  static properties = {
    height: {
      type: String,
    },
    width: {
      type: String,
    },
    strokeColor: {
      type: String,
      attribute: 'stroke-color',
    },
  };

  constructor() {
    super();
    this.height = '17';
    this.width = '16';
    this.strokeColor = '#026EDD';
  }

  render() {
    return html`
      <svg width="${this.width}" height="${this.height}" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.5 10.75L8 13.76L11.5 10.75" stroke="${this.strokeColor}" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M8 2.75V13.76" stroke="${this.strokeColor}" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;
  }
}
customElements.define('tenable-icon-arrow-down', IconArrowDown);
